import { IRecaptchaService } from '../interfaces/recaptcha-service.interface';
import { BehaviorSubject } from '@contorion/core/rxjs';

class RecaptchaService implements IRecaptchaService {
    private captchaLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private captchaError: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private captchaSuccess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public setCaptchaError(): void {
        this.captchaError.next(true);
    }

    public setCaptchaSuccess(): void {
        this.captchaSuccess.next(true);
    }

    public setCaptchaLoaded(): void {
        this.captchaLoaded.next(true);
    }

    public subscribeOnCaptchaError(subscriber: (error: boolean) => void): void {
        this.captchaError.subscribe(subscriber);
    }

    public subscribeOnCaptchaSuccess(subscriber: (success: boolean) => void): void {
        this.captchaSuccess.subscribe(subscriber);
    }

    public subscribeOnCaptchaLoad(subscriber: (loaded: boolean) => void): void {
        this.captchaLoaded.subscribe(subscriber);
    }
}

export const recaptchaService: RecaptchaService = new RecaptchaService();
